import React, { useState } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'

import {
    FolderOutlined
} from '@ant-design/icons';
import withDoubleClick from './hoc/withDoubleClick';

// const DirectoryFolderComponent = ({ data, index, handleItemClicked = () => { } }) => {
//     return (
//         <Draggable draggableId={`${data.id}`} index={index}>
//             {provided => (


//                 <Droppable droppableId={"0"}>
//                     {provided2 => (
//                         <div ref={provided2.innerRef} {...provided2.droppableProps}>
//                             <div onClick={() => { handleItemClicked(data) }} style={{ display: "flex" }}
//                                 {...provided.draggableProps}
//                                 {...provided.dragHandleProps}
//                                 ref={provided.innerRef}
//                             >
//                                 <FolderOutlined style={{ fontSize: 30 }} />{data.name}
//                             </div>
//                         </div>
//                     )}
//                 </Droppable>


//             )}
//         </Draggable>
//     )
// }
const DirectoryFolderComponent = ({ data, index, handleItemClicked = () => { }, onItemUpdated = () => { } }) => {

    const [isFocus, setIsFocus] = useState(false);

    function allowDrop(ev) {
        setIsFocus(true)
        ev.preventDefault();
    }
    function dragLeave(ev) {
        setIsFocus(false)
        ev.preventDefault();
    }

    function drag(ev, itemData) {
        ev.dataTransfer.setData("itemData", JSON.stringify(itemData));
    }

    function drop(ev) {
        setIsFocus(false)
        var dataString = ev.dataTransfer.getData("itemData");
        var targetData = JSON.parse(dataString)

        if (data.id === targetData.id)
            return;

        targetData.parentID = data.id
        onItemUpdated(targetData)
        ev.preventDefault();
        // ev.target.appendChild(document.getElementById(data));
    }

    return (
        <div style={{ display: "flex", fontWeight: isFocus ? `600` : `400` }} onDrop={drop} onDragLeave={dragLeave} onDragOver={allowDrop} draggable={true} onDragStart={(evt) => drag(evt, data)} >
            <FolderOutlined style={{ fontSize: 30 }} />{data.name}
        </div>
    )
}

export default withDoubleClick(DirectoryFolderComponent) 